import { isLoggedIn } from '@utils/auth'
import { getUrgenciesApi } from './api'
export const state = {
  urgencies: [],
}

export const getters = {
  urgencies(state) {
    return state.urgencies
  },
  urgencyOptions(state) {
    const urgencies = state.urgencies
    return urgencies.map((p) => ({
      default: p.default,
      color: p.color,
      key: p.id,
      text: p.name,
    }))
  },
}

export const mutations = {
  SET_URGENCIES(state, data) {
    state.urgencies = data
  },
}

export const actions = {
  init({ dispatch }) {
    if (isLoggedIn()) {
      dispatch('fetch')
    }
  },

  fetch({ commit }, params) {
    return getUrgenciesApi(params).then((data) => {
      commit('SET_URGENCIES', data)
      return data
    })
  },

  /**
   * destroy all states when user is logged out
   */
  destroy({ commit }) {
    commit('SET_URGENCIES', [])
  },
}
